import { useTheme } from '@mui/material/styles';

const useMuiComponentsOverrides = () => {
  const { breakpoints, palette, spacing } = useTheme();

  const muiComponentsOverrides = {
    // Main search toolbar
    '.MuiToolbar-root': {
      '.MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [breakpoints.down('sm')]: { maxWidth: '180px' }
      }
    },

    // Page
    '.page': {
      overflow: 'hidden',
      minHeight: '100%',
      [breakpoints.down('sm')]: { paddingBottom: '88px !important' } // Bottom navbar mobile
    },

    // ToggleButtonGroup
    '.MuiToggleButtonGroup-root': {
      '.MuiButtonBase-root': {
        color: `${palette.primary.main} !important`,
        borderColor: `${palette.primary.main} !important`,
        ':hover': {
          color: `${palette.common.white} !important`,
          backgroundColor: `${palette.primary.dark} !important`
        }
      },
      '.Mui-selected': {
        color: `${palette.common.white} !important`,
        backgroundColor: `${palette.primary.main} !important`
      }
    },

    // Snackbar (DS) : supprime le padding MUI sur l'action pour éviter le décalage
    '.SnackbarContainer-top': {
      marginTop: 'env(safe-area-inset-top)'
    },
    '.MuiSnackbar-root .MuiAlert-action': {
      padding: '0 !important'
    },

    // Table (DS ou MUI) : aligner l'en-tête sur le reste (pas de divider en haut, même fond)
    // En GlobalStyles pour gagner en spécificité en build face au design system
    '.MuiTableCell-head': {
      borderBottom: `1px solid ${palette.divider} !important`,
      borderTop: `none !important`,
      '.MuiButtonBase-root': {
        color: `${palette.text.secondary} !important`
      }
    },
    // DS : supprime le margin MUI sur le sélecteur de nombre de lignes
    // ar page et les boutons de navigation entre les pages
    '.MuiTablePagination-root': {
      '.MuiInputBase-root': {
        marginRight: `${spacing(1)} !important`
      },
      '.MuiTablePagination-actions': {
        marginLeft: `0 !important`
      }
    },

    // Popovers (ex: DotMenu) : conserver les retours à la ligne et les espaces
    '.MuiPopover-paper': {
      '.MuiListItemText-secondary': {
        whiteSpace: 'break-spaces'
      }
    },

    '.MuiFormLabel-asterisk': {
      color: `${palette.error.main} !important`,
    }
  };

  return { muiComponentsOverrides };
};

export default useMuiComponentsOverrides;
